import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import GstDisclaimer from '../../../../common/product/GstDisclaimer';
import Conditional from '../../../../common/Conditional';
import ProductPrice from './ProductPrice';
import ProductUpsell from './ProductUpsell';
import CoreDeposit from './CoreDeposit';
import { InlineLoader } from 'cat-ecommerce-alloy';

const ProductPriceDetails = ({
  isLoading,
  isPriceCallComplete,
  productId,
  showPrice,
  uniqueId
}) => {
  const taxDisclaimerMessage = useSelector(
    s => s.dealerCustomer?.taxDisclaimerMessage
  );
  return (
    <>
      <div className="row">
        {showPrice && (
          <Conditional
            fallback={<InlineLoader className="col-12 col-lg-auto" />}
            test={!isLoading}
          >
            <ProductPrice productId={productId} />
          </Conditional>
        )}
        <ProductUpsell
          isPriceCallComplete={isPriceCallComplete}
          uniqueId={uniqueId}
        />
      </div>
      <CoreDeposit productId={productId} />
      {!!taxDisclaimerMessage && (
        <GstDisclaimer className="py-2" taxMessage={taxDisclaimerMessage} />
      )}
    </>
  );
};

ProductPriceDetails.propTypes = {
  isLoading: PropTypes.bool,
  isPriceCallComplete: PropTypes.bool,
  productId: PropTypes.string,
  showPrice: PropTypes.bool,
  uniqueId: PropTypes.string
};

export default ProductPriceDetails;
